import { render, staticRenderFns } from "./TapJoyIcon.vue?vue&type=template&id=6c2a136c&"
import script from "./TapJoyIcon.vue?vue&type=script&lang=js&"
export * from "./TapJoyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports